import ResizeObserver from 'resize-observer-polyfill';
import Vue from 'vue';
import {containerID, breakpoint, assets_path} from '@/_constant/variables';
import utils from '@/_modules/utils';
import store from '@/_modules/stores';
import GlobalHeader from '@/_components/global-header.vue';
import ReviewStar from '@/_components/review-star.vue';
import Gmap from '@/_modules/Gmap';
import SetAnchor from '@/_modules/SetAnchor'
import Swiper, {Navigation, Pagination, Autoplay, EffectFade} from 'swiper';

export default class pageCommon {
  constructor() {
    this.getHeight100();
    this.winH = 0;
    this.conH = 0;

    const _init = this.init.bind(this);

    this.vue = new Vue({
      components: {
        GlobalHeader,
        ReviewStar,
      },
      data() {
        return {
          resizeObserver: null,
          breakpoint: breakpoint,
          assets_path: assets_path,
        }
      },
      el: containerID,
      store,
      mounted() {
        // リサイズイベント
        this.resize();
        window.addEventListener('resize', this.resize);
        this.resizeObserver = new ResizeObserver(this.resize);
        this.resizeObserver.observe(document.body);

        // 初回設定
        this.$nextTick(this.init);
      },
      methods: {
        init() {
          _init();
        },
        start() {
          
        },
        resize() {
          if (window.innerWidth > breakpoint) {
            this.$store.commit('setPc', true);
          } else {
            this.$store.commit('setPc', false);
          }
        }
      }
    });
  }

  init() {    
    // カルーセル
    new Swiper('.swiper', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 4000,
      },
      loop: true,
      speed: 800,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  start() {
    // Googleマップ
    new Gmap();

    // アンカーリンク
    new SetAnchor();
  }

  getHeight100() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
}
